module.exports = __webpack_public_path__ + "img/empty_data.528e18ce.svg";